export enum LocalStorageKey {
    PREVIOUS_LOCATION = 'previousLocation',
    BENEFIT_KEYS = 'benefitKeys'
}